<script>
  /* eslint-disable new-cap */
import Layout from '@layouts/primary'
import { collectionMethods,pickupRequestMethods } from '@state/helpers'
import store from '@state/store'
import moment from 'moment-timezone'
import ListLoading from '../../components/loading'
export default {
  $_veeValidate: {
    validator: 'new',
  },
  page: {
    title: 'RequestedCollections',
    meta: [{ name: 'description', content: 'RequestedCollections' }],
  },
  components: { Layout, ListLoading },
  data() {
    return {
      loadingData:true,
      search: '',
      headers: [
        { text: 'Transaction Id', value: 'transaction_id' , width: "10%" },
        { text: 'Client Name', value: 'service.service_title' },
        { text: 'Service Title', value: 'service.service_title' },
        { text: 'Pickup Date', value: 'dateSeconds', width: "10%" },
        { text: 'Status', value: 'status', width: "10%" },
        { text: 'Actions', value: 'pickup_date', sortable:false }
      ],
      editCollection: false,
      createBookingFlag:false,
      cancelPickup:false,
      currentPickup: null,
      pickuprequests:[],
      collection:{},
      dictionary: {
        attributes: {
          // email: 'E-mail Address',
          // custom attributes
        },
        custom: {
          // name: {
          //   required: () => 'Name can not be empty',
          //   max: 'The name field may not be greater than 10 characters',
          //   // custom messages
          // },
          select: {
            required: 'Select field is required',
          },
        }
      },
    }
  },
  mounted() {
    this.$validator.localize('en', this.dictionary)
    // let moment = require('moment');

    this.getPickupRequests().then(response=>{
      let moment = require('moment');
      let obj = this.$store.state.pickuprequest.pickuprequest
      for(let v in obj){
        if(obj[v] && obj[v].client){
          obj[v].dateSeconds = moment(obj[v].pickup_date_raw).valueOf()
          // console.log(obj[v])
          this.pickuprequests.push(obj[v]);
        }
      }
      if(this.pickuprequests.length > 0){
        this.currentPickup = this.pickuprequests[0];
      }
      this.loadingData=false;
    });


  },
  methods: {
    ...pickupRequestMethods,
    ...collectionMethods,
    submit() {
      this.$validator.validateAll()
    },
    clear() {
      this.$validator.reset()
    },
    changeRoute(r) {
      this.$router.push(r)
    },
    cancelBooking(item){
      // console.log(item)
      this.currentPickup = item;
      // this.pickuprequests = item;
      this.cancelPickup = true;
    },
    createBooking(item){
      this.currentPickup = item;
      this.createBookingFlag = true;
      // this.pickuprequests = item;

    },
    async cancel(item){
      await this.updatePickupRequestStatus({id:item.id,status:"CANCELLED"})
        .then((result) => {
          if(result){
            location.reload()
          }
        })
    },
    async createBookingCollection(){
      let userId = store.getters['auth/getUserId'];
      let date = moment.utc().toISOString()
      // let date = moment(this.currentPickup.pickup_date_raw).format('YYYY-MM-DD')
      // console.log(date)
      // let date = this.currentPickup.pickup_date_raw

      await this.createCollectionFromPickupRequest({
        pickup_id: parseInt(this.currentPickup.id),
        service_id: parseInt(this.currentPickup.service.id),
        collection_date: date,
        processed: false,
        completed: false,
        created_by: parseInt(userId)
      }).then((res) => {
        this.$router.push('/admin/reassign-collections/');
        location.reload()
      }).catch((err)=>{
        console.log(err)
      })
    }

  },
}
</script>

<template>
  <Layout>
    <VContainer>
      <div class="">
        <h2 :class="$style.routeHeader">
          Requested Collections
        </h2>
      </div>
      <ListLoading :display="loadingData" />
      <VLayout style="width: 100%">

        <VFlex
          xs0
          sm12
        />
        <VFlex
          xs12
          md5
        >
          <VTextField
            v-if="!loadingData"
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </VFlex>
      </VLayout>

      <div v-if="pickuprequests">
        <VDataTable
          v-if="!loadingData"
          :headers="headers"
          :items="pickuprequests"
          :search="search"
          rows-per-page-text=""
          :rows-per-page-items="[10]"
        >
          <template
            slot="items"
            slot-scope="props"
          >
            <td class="text-xs-left">
              {{ props.item.transaction_id }}
            </td>
            <td
              v-if="props.item.client"
              class="text-xs-left"
            >
              {{ props.item.client.client_name }}
            </td>
            <td
              v-if="!props.item.client"
              class="text-xs-left"
            >
              {{ 'Client deleted' }}
            </td>
            <td class="text-xs-left">
              {{ props.item.service.service_title }}
            </td>
            <td class="text-xs-left">
              {{ props.item.pickup_date }}
            </td>
            <td class="text-xs-left">
              {{ props.item.status }}
            </td>
            <td
              style="
                display: flex;
                flex-direction: row;
                justify-items: center;
                align-content: center;
                align-items: center;
              "
            >
              <VBtn
                v-if="props.item.status=='PENDING'"
                slot="activator"
                style="display: block; position:relative; margin: 0 auto"
                color="blue"
                @click.native="createBooking(props.item)"
              >
                Book
              </VBtn>
              <VBtn
                v-if="props.item.status=='PENDING'"
                slot="activator"
                style="display: block; position:relative; margin: 0 auto"
                color="orange"
                @click.native="cancelBooking(props.item)"
              >
                Decline
              </VBtn>
            </td>

          </template>
        </VDataTable>
      </div>

      <VLayout
        v-if="currentPickup!=null"
        row
        justify-center
      >
        <VDialog
          v-model="cancelPickup"
          persistent
          max-width="550px"
          scrollable
        >
          <VCard>
            <VCardText>
              <VContainer grid-list-md>
                <h2>Are you sure you want to decline booking {{ currentPickup.transaction_id }}?</h2>
                <br>
                <VLayout wrap>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      outline
                      @click.native="cancelPickup = !cancelPickup"
                    >
                      Close
                    </VBtn>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="orange"
                      block
                      @click.native="cancel(currentPickup)"
                    >
                      DECLINE
                    </VBtn>
                  </VFlex>
                </VLayout>
              </VContainer>
            </VCardText>
          </VCard>
        </VDialog>
      </VLayout>

      <VLayout
        v-if="currentPickup!=null"
        row
        justify-center
      >
        <VDialog
          v-model="createBookingFlag"
          persistent
          max-width="550px"
          scrollable
        >
          <VCard>
            <VCardText>
              <VContainer grid-list-md>
                <h2>Are you sure you want to create a booking at {{ currentPickup.service.site.address +" " +currentPickup.service.site.suburb + " "+currentPickup.service.site.country + " on "+currentPickup.pickup_date }}?</h2>
                <br>
                <VLayout wrap>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      outline
                      @click.native="createBookingFlag = !createBookingFlag"
                    >
                      Close
                    </VBtn>
                  </VFlex>
                  <VFlex
                    xs12
                    sm6
                    md6
                  >
                    <VBtn
                      color="blue"
                      block
                      @click.native="createBookingCollection(currentPickup)"
                    >
                      Book
                    </VBtn>
                  </VFlex>
                </VLayout>
              </VContainer>
            </VCardText>
          </VCard>
        </VDialog>
      </VLayout>

    </VContainer>
  </Layout>
</template>

<style lang="scss" module>
  @import '@design';

  .routeHeader {
    display: inline-block;
  }

  .addButton {
    display: inline-block;
    float: right;
  }
</style>
